import moment from 'moment';
import c from '@/components/Core/constants.js'
import 'twix';
import jquery from 'jquery';
var allEvtIds = [];

function getEventForTheDate(date, eventStore) {
	var eventObj = [];
	for (var key in eventStore.instances) {
		// skip loop if the property is from prototype
		if (!eventStore.instances.hasOwnProperty(key)) continue;
		var r = eventStore.instances[key]['range'];
		var defId = eventStore.instances[key]['defId'];

		const range = moment(r.start).twix(r.end, true);
		if (range.contains(date)) {
			var x = {
				Status: eventStore.defs[defId].extendedProps.EventObj.Status,
				ExpenseStatus:eventStore.defs[defId].extendedProps.EventObj.ExpenseStatus,
				CalendarType: eventStore.defs[defId].extendedProps.EventObj.CalendarType,
				eventStoreInstanceKey: key,
				TimesheetlatestLog:eventStore.defs[defId].extendedProps.EventObj.TimesheetlatestLog,
				ExpenselatestLog:eventStore.defs[defId].extendedProps.EventObj.ExpenselatestLog,
			};
			eventObj.push(x);
		}
	}

	return eventObj;
}

function createCell(label, date, eventStore, _this) {
	let isToday = false;
	let eventData = null;

	if (date) {
		isToday = moment(date, 'YYYY-MM-DD').isSame(moment(), 'day');

		eventData = getEventForTheDate(date, eventStore);
	}
	let dateSpanStyle = 'margin-top: 7px;display: inline-block;';
	let classes = 'fc-ob-cell';
	var eventIds = [];
	if (isToday) {
		classes += ' current-date';
		dateSpanStyle = 'margin-top: 0px;display: inline-block;';
	}

	if (eventData != null && eventData.length > 0) { 
		for (let k = 0; k < eventData.length; k++) {
			var x = eventData[k];
			var innerSpan = '';
			eventIds[k] = x.eventStoreInstanceKey; 
			if (x.CalendarType == 'TimeSheet' && (x.Status == 'Approved' || x.ExpenseStatus == 'Approved')) {
				if((x.TimesheetlatestLog != null && x.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit') || (x.ExpenselatestLog != null && x.ExpenselatestLog.Status == 'EmployeeRequestedForEdit')){
					if (k == 0) {
						classes += ' fc-ce-bg fc-ce-timesheet-EmployeeRequestedForEdit';
					} else innerSpan = `display: block;background:rgb(177, 197, 232,0.7)`;
				}
				else if(x.Status == 'Approved' && x.InvoiceStatus == 'Invoice Generated' && x.InvoiceDates.includes(date)){
					if (k == 0) {
						classes += ' fc-ce-bg fc-ce-timesheet-invoiceGenerated';
						totalTimeColr = '#A31D95';
					} 
					if(k > 0){
						totalTimeColr = '#A31D95';
					}
					else innerSpan = `display: block;`;
				}
				else{
					if (k == 0) {
						classes += ' fc-ce-bg fc-ce-timesheet-approved';
					} else innerSpan = `display: block;background:rgb(190, 244, 219,0.7)`;
				}
			} else if (x.CalendarType == 'TimeSheet' && (x.Status == 'Pending' || x.ExpenseStatus == 'Pending')) {
				if (k == 0) {
					classes += ' fc-ce-bg fc-ce-timesheet-pending';
				} else innerSpan = `display: block;background:rgb(252, 239, 182,0.7)`;
			} else if (x.CalendarType == 'TimeSheet' && (x.Status == 'Rejected' || x.ExpenseStatus == 'Rejected')) {
				if (k == 0) {
					classes += ' fc-ce-bg fc-ce-timesheet-rejected';
				} else innerSpan = `display: block;background:rgb(253, 234, 229,0.7)`;
			} else if (x.CalendarType == 'Leave' && x.Status == 'Pending') {
				if (k == 0) {
					classes += ' fc-ce-bg fc-ce-leave-pending';
				} else innerSpan = `display: block;background:rgb(217, 217, 217,0.7)`;
			} else if (x.CalendarType == 'Leave' && x.Status == 'Approved') {
				if (k == 0) {
					classes += ' fc-ce-bg fc-ce-leave-approved';
				} else innerSpan = `display: block;background:rgb(223, 228, 247,0.7)`;
			}  else if (x.CalendarType == 'TimeSheet' && (x.Status == 'Saved' || x.ExpenseStatus == 'Saved')) { 
				if (k == 0) {
					classes += ' fc-ce-bg fc-ce-timesheet-saved';
				} else innerSpan = `display: block;background:rgb(223, 228, 247,0.7)`;
			} else if (eventData.CalendarType == 'Holiday') {
				if (k == 0) {
					classes += ' fc-ce-bg fc-ce-leave-pending';
				} else innerSpan = `display: block;background:rgb(188, 188, 246,0.7)`;
			}
		}
		var left = 0;
		var right = 0;
		var innerSpanStyle = '';
		if (!allEvtIds.includes(eventIds[1])) {
			innerSpan += `;margin: 0px 0px 0px 2px`;
		}
		if (allEvtIds.some((v) => eventIds.indexOf(v) !== -1)) {
			left = 0;
			right = 0;
		} else {
			allEvtIds = allEvtIds.concat(eventIds);
			left = '5%';
			right = '5%';
		}
		if (eventIds.length > 1) {
			innerSpanStyle = innerSpan;
		} else {
			innerSpanStyle = '';
		}

		return `<td><div style="padding: 10px;" class="${classes}" data-eventstore-instance-key='${eventIds}'>&nbsp;<span style="left:${left};right:${right}"><span style="${innerSpanStyle}"> <span style="${dateSpanStyle}">${label}</span></span></span></div></td>`;
	}

	return `<td><div style="padding: 10px;" class="${classes}">&nbsp;<span><span style="${dateSpanStyle}">${label}</span></span></div></td>`;
}

function getMOnthlyExpense(cData, month){
	var clData = cData.filter((v) => v.Status != 'Rejected');
	var expesnePerDayList = clData.filter((v) => v.HoursPerDay != null).map(function(v) {
		return v.HoursPerDay;
	});

	var mergedhoursPerDayList = [].concat.apply([], expesnePerDayList);
	var mergedexpensePerDayListCurrentMonth = mergedhoursPerDayList.filter((x) => {
		return moment(x.Date).format('YYYY-MM') == month;
	});
	var expnese = 0;
	let monthlyExpense = '0';
	for (var j = 0; j < mergedexpensePerDayListCurrentMonth.length; j++) {
		var x = mergedexpensePerDayListCurrentMonth[j];
		let Expensetotal = 0;
		if (x.TotalExpense != null && x.TotalExpense != undefined && x.TotalExpense != '') {
			Expensetotal = x.TotalExpense
		}
		//var ex = 0;
		if (Expensetotal) {
			expnese += Expensetotal;
			// if (ex) {
			// 	expnese = expnese + (parseInt(ex) || 0);
			// }
		}
	}

	monthlyExpense = `<span class="hours_span">${expnese}</span>`;
	return monthlyExpense
}
function getMonthlyHours(cData, month) {
	var data = cData.filter((v) => v.Status != 'Rejected');
	var hoursPerDayList = data.filter((v) => v.HoursPerDay != null).map(function(v) {
		return v.HoursPerDay;
	});
	var mergedhoursPerDayList = [].concat.apply([], hoursPerDayList);
	var mergedhoursPerDayListCurrentMonth = mergedhoursPerDayList.filter((x) => {
		return moment(x.Date).format('YYYY-MM') == month;
	});
	var hrs = 0;
	var min = 0;
	let monthlyHours = '0h';
	for (var j = 0; j < mergedhoursPerDayListCurrentMonth.length; j++) {
		var x = mergedhoursPerDayListCurrentMonth[j];
		let total = new Array();
		if (x.Hours != null && x.Hours != undefined && x.Hours != '') {
			total = x.Hours.split(' ');
		}
		var h = 0;
		var m = 0;
		if (total.length == 2) {
			h = total[0];
			m = total[1];
			if (h) {
				hrs = hrs + (parseInt(h.replace('h', '')) || 0);
			}
			if (m) {
				min = min + (parseInt(m.replace('m', '')) || 0);
			}
		} else if (total.length == 1) {
			if (total[0].includes('h')) {
				h = total[0];
			} else if (total[0].includes('m')) {
				m = total[0];
			}
			if (h) {
				hrs = hrs + (parseInt(h.replace('h', '')) || 0);
			}
			if (m) {
				min = min + (parseInt(m.replace('m', '')) || 0);
			}
		}
	}
	var hours = min / 60;
	var rhours = Math.floor(hours);
	var minutes = (hours - rhours) * 60;
	var rminutes = Math.round(minutes);
	var totalHours = parseInt(hrs) + parseInt(rhours);

	if (totalHours != 0 && rminutes != 0) {
		monthlyHours = `<span class="hours_span">${totalHours +
			'</span><p class="hours_p">h</p> <span class="hours_span">'}${rminutes +
			'</span><p class="hours_p">m</p>'}`;
	} else if (totalHours != 0 && rminutes == 0) {
		monthlyHours = `<span class="hours_span">${totalHours + '</span><p class="hours_p">h</p>'}`;
	} else if (totalHours == 0 && rminutes != 0) {
		monthlyHours = `<span class="hours_span">${rminutes + '</span><p class="hours_p">m</p>'}`;
	} else {
		monthlyHours = `<span class="hours_span">0</span><p class="hours_p">h</p>`;
	}
	return monthlyHours;
}
const MonthsRender = (year, eventStore, _this) => {
	// alert(year);
	let tempDOM = '';

	tempDOM += `<div class="fc-ob-months-render-container"><table class="fc-ob-months-render">`;

	const monthNames = [
		{
			name: 'JAN',
			days: 31,
			firstDayOfMonth: `${year}-01-01`,
			YYYYMM: `${year}-01`,
			MonthNumber: 1
		},
		{
			name: 'FEB',
			days: 28,
			firstDayOfMonth: `${year}-02-01`,
			YYYYMM: `${year}-02`,
			MonthNumber: 2
		},
		{
			name: 'MAR',
			days: 31,
			firstDayOfMonth: `${year}-03-01`,
			YYYYMM: `${year}-03`,
			MonthNumber: 3
		},
		{
			name: 'APR',
			days: 30,
			firstDayOfMonth: `${year}-04-01`,
			YYYYMM: `${year}-04`,
			MonthNumber: 4
		},
		{
			name: 'MAY',
			days: 31,
			firstDayOfMonth: `${year}-05-01`,
			YYYYMM: `${year}-05`,
			MonthNumber: 5
		},
		{
			name: 'JUN',
			days: 30,
			firstDayOfMonth: `${year}-06-01`,
			YYYYMM: `${year}-06`,
			MonthNumber: 6
		},
		{
			name: 'JUL',
			days: 31,
			firstDayOfMonth: `${year}-07-01`,
			YYYYMM: `${year}-07`,
			MonthNumber: 7
		},
		{
			name: 'AUG',
			days: 31,
			firstDayOfMonth: `${year}-08-01`,
			YYYYMM: `${year}-08`,
			MonthNumber: 8
		},
		{
			name: 'SEP',
			days: 30,
			firstDayOfMonth: `${year}-09-01`,
			YYYYMM: `${year}-09`,
			MonthNumber: 9
		},
		{
			name: 'OCT',
			days: 31,
			firstDayOfMonth: `${year}-10-01`,
			YYYYMM: `${year}-10`,
			MonthNumber: 10
		},
		{
			name: 'NOV',
			days: 30,
			firstDayOfMonth: `${year}-11-01`,
			YYYYMM: `${year}-11`,
			MonthNumber: 11
		},
		{
			name: 'DEC',
			days: 31,
			firstDayOfMonth: `${year}-12-01`,
			YYYYMM: `${year}-12`,
			MonthNumber: 12
		}
	];

	// Leap year check
	let isLeapYear = year % 4 == 0 ? true : false;
	if (isLeapYear) {
		monthNames[1].days = 29; // update Feb to 29
	}

	var x = Object.entries(eventStore.defs); //Convert to List Array
	var AllEvents = x.map(function(v) {
		return v[1].extendedProps.EventObj;
	}); // get Event Objct
    var MonthlyHoursAndExpenses = x.map(function(v) {
		return v[1].extendedProps.monthlyHoursAndExpense;
	})[0];
	monthNames.forEach((m) => { 
		let d = moment(m.firstDayOfMonth).day();
		let diff = 7 - d;

		var expense = 0.00;
		if(MonthlyHoursAndExpenses != undefined && MonthlyHoursAndExpenses[m.MonthNumber-1] != undefined)
		{
			expense = MonthlyHoursAndExpenses[m.MonthNumber-1].TotalExpenseAmount;
		}
		let startDate = moment(m.firstDayOfMonth).format('MM/DD/YYYY');
		let endDate = moment(startDate).add(1, 'months').format('MM/DD/YYYY');
		var result = AllEvents.filter(function(obj) {
			let date = moment(obj.FromDate).format('MM/DD/YYYY');
			return date >= startDate && date < endDate;
		});
		if (diff < 7) {
			// Not Sunday
			let limit = 35 - d;

			tempDOM += `<tr style="height: 50px;">`;
			tempDOM += `<td  style="width:250px;background-image:url('${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/search_background.png')">
                <div style="display: inline-block;float: left;width:30px;padding: 10px;" class="fc-ob-cell">${m.name}</div>
                <div style="text-align: initial;display: inline-block;background: white;height: 14px;width:180px;padding: 5px 0px 19px 15px;margin-left: -20px;" class="fc-ob-cell">
				  <div class="hrtooltip">
				    <img style="width: 18px;padding-bottom: 4px;display: inline-block;" src="${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_totalhours.svg"/>
				    <span class="hrtooltiptext">Total hours worked</span>
			      </div>
                <b style="display: inline-block;margin-left:2px">${getMonthlyHours(
					AllEvents,
					m.YYYYMM
				)} <span month="${m.name}" class="hours-res" style="padding-left: 5px;"><i  class="fa fa-sort-desc" aria-hidden="true"></i></span> <img style="width: 16px;padding-bottom:4px;padding-left:10px;display: inline-block;" src="${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_dollar.svg"/><b style="display: inline-block;margin-left:2px">${expense}</b><span month="${m.name}" class="expense-res" style="padding-left: 5px;"><i  class="fa fa-sort-desc" aria-hidden="true"></i></span></div>
				</td>`;

			let startDash = 0;
			let prependDiff = m.days + d - 35;
			if (prependDiff > 0) {
				for (var i = 0; i < prependDiff; i++) {
					let t = m.days - (prependDiff - 1 - i);
					tempDOM += createCell(t, m.YYYYMM + '-' + t, eventStore, _this);
				}
				startDash = prependDiff;
			}

			for (var i = startDash; i < d; i++) {
				tempDOM += createCell('-', null, eventStore, _this);
			}

			for (var i = 1; i <= limit; i++) {
				if (i > m.days) {
					tempDOM += createCell('-', null, eventStore, _this);
				} else {
					tempDOM += createCell(i, m.YYYYMM + '-' + i, eventStore, _this);
				}
			}

			tempDOM += `</tr>`;
		} else {
			tempDOM += `<tr  style="height: 50px;">`;
			tempDOM += `<td  style="width:250px;background-image:url('${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/search_background.png')">
     		 <div style="display: inline-block;float: left;width:30spx;padding: 10px;" class="fc-ob-cell">${m.name}</div>
     		 <div style="text-align: initial;display: inline-block;background: white;height: 14px;width:180px;padding: 5px 0px 19px 15px;margin-left: -20px;" class="fc-ob-cell">
			 <div class="hrtooltip">
			 <img style="width: 18px;padding-bottom: 4px;display: inline-block;" src="${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_totalhours.svg"/>
			 <span class="hrtooltiptext">Total hours worked</span>
			 </div>
	         <b style="display: inline-block; margin-left: 2px;">${getMonthlyHours(AllEvents, m.YYYYMM)}<span month="${m.name}" class="hours-res" style="padding-left: 5px;"><i  class="fa fa-sort-desc" aria-hidden="true"></i></span> <img style="width: 16px;padding-bottom: 4px;padding-left:10px;display: inline-block;" src="${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_dollar.svg"/><b style="display: inline-block; margin-left: 2px;">${expense} </b><span month="${m.name}" class="expense-res" style="padding-left: 5px;"><i  class="fa fa-sort-desc" aria-hidden="true"></i></span></div></td>`;

			for (var i = 1; i <= 35; i++) {
				if (i > m.days) {
					tempDOM += createCell('-', null, eventStore, _this);
				} else {
					tempDOM += createCell(i, m.YYYYMM + '-' + i, eventStore, _this);
				}
			}

			tempDOM += `</tr>`;
		}
	});

	tempDOM += `</table></div>`;

	return tempDOM;
};

export default MonthsRender;



// WEBPACK FOOTER //
// ./src/components/ESSProfile/Timesheets/Calender/CustomViews/Yearly/MonthsRender/MonthsRender.js